
import Multiselect from 'vue-multiselect';

export default {
    name: "FilterDropdownAgeMobile",
    components: {
        Multiselect,
    },
    props: {
        filterTitle: {
            type: String,
            required: true,
            default: '',
        },
        actualValue: {
            required: true,
            // default: () => {},
        },
        filterOptions: {
            type: Array,
            required: true,
            default: () => [],
        },

        mode: {
            type: String,
            required: false,
            default: 'default',
        },

        isMultiple: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            value: null,
            options: [
                { name: 'Vue.js' },
                { name: 'Rails' },
                { name: 'Sinatra' },
                { name: 'Laravel' },
                { name: 'Phoenix' }
            ],
            tempValue: this.mode.includes('show-default-value')
            ? this.actualValue
            : { value: null, text: this.filterTitle, id: null },
            placeholderValue: { value: null, text: this.filterTitle, id: null },
            displayValue: this.isMultiple || this.mode.includes('show-default-value') ? this.actualValue : '',

            filterDataActualValue: this.actualValue,
            isSelected: false,
            storeMode: this.$store.getters['modal/showDisplayMobileFilter'].mode
        }
    },
    mounted() {
        this.$nextTick(() => {
            const type = this.mode.split(' ');
            const storeMode = this.$store.getters['modal/showDisplayMobileFilter'].mode;
            if (type[0] == storeMode) {
                this.$refs.multiselect.activate();
            }
        })
    },
    methods: {
        onInput(value) {
            // this.isSelected = true;

            // save to tempValue
            this.tempValue = value;

            // modify actualValue
            this.filterDataActualValue = this.tempValue;
            this.$emit('update:actualValue', this.tempValue);

            if (this.displayValue === undefined || this.displayValue?.length === 0) {
                this.isSelected = false;
            }
        },

    }
}
